module.exports = __webpack_public_path__ + "static/media/sidebar-1.51ece57d.jpg";